import { useState } from 'react';
import { motion } from 'framer-motion';

const SITE_URL  = 'https://glummies.xyz';
const SHARE_MSG = "Just secured my WL spot 🌈 @Glummies_ — 2222 hand-drawn NFTs dropping on Robinhood Chain.\n\nSecure yours 👉 https://glummies.xyz/";

/* ── SVG brand icons (inline so there's no extra dependency) ── */
function XIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.402 6.231H2.747l7.73-8.835L1.254 2.25H8.08l4.259 5.63L18.244 2.25zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z" />
    </svg>
  );
}

function WhatsAppIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  );
}

function TelegramIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
    </svg>
  );
}

function DiscordIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
      <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
    </svg>
  );
}

function RedditIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
      <path d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.534A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248.687 0 1.248-.561 1.248-1.249 0-.688-.561-1.249-1.249-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25 0 .687.561 1.248 1.249 1.248.688 0 1.249-.561 1.249-1.249 0-.687-.562-1.249-1.25-1.249zm-5.466 3.99a.327.327 0 0 0-.231.094.33.33 0 0 0 0 .463c.842.842 2.484.913 2.961.913.477 0 2.105-.056 2.961-.913a.361.361 0 0 0 .029-.463.33.33 0 0 0-.464 0c-.547.533-1.684.73-2.512.73-.828 0-1.979-.196-2.512-.73a.326.326 0 0 0-.232-.095z" />
    </svg>
  );
}

/* ── Platform definitions ─────────────────────────────────────── */
const platforms = [
  {
    name: 'X',
    tagline: 'Post about Glummies',
    cta: 'Tweet It',
    bg: '#000000',
    text: '#ffffff',
    border: '#333333',
    Icon: XIcon,
    href: () =>
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(SHARE_MSG)}&url=${encodeURIComponent(SITE_URL)}`,
  },
  {
    name: 'WhatsApp',
    tagline: 'Send to your contacts',
    cta: 'Share',
    bg: '#25D366',
    text: '#ffffff',
    border: '#1ebe5d',
    Icon: WhatsAppIcon,
    href: () =>
      `https://wa.me/?text=${encodeURIComponent(SHARE_MSG)}`,
  },
  {
    name: 'Telegram',
    tagline: 'Drop it in your chats',
    cta: 'Share',
    bg: '#229ED9',
    text: '#ffffff',
    border: '#1a8fc4',
    Icon: TelegramIcon,
    href: () =>
      `https://t.me/share/url?url=${encodeURIComponent(SITE_URL)}&text=${encodeURIComponent(SHARE_MSG)}`,
  },
  {
    name: 'Discord',
    tagline: 'Post in your server',
    cta: 'Copy Link',
    bg: '#5865F2',
    text: '#ffffff',
    border: '#4752c4',
    Icon: DiscordIcon,
    href: null, // uses clipboard copy
  },
  {
    name: 'Reddit',
    tagline: 'Share with your community',
    cta: 'Post It',
    bg: '#FF4500',
    text: '#ffffff',
    border: '#e03d00',
    Icon: RedditIcon,
    href: () =>
      `https://www.reddit.com/submit?url=${encodeURIComponent(SITE_URL)}&title=${encodeURIComponent('Glummies — 2222 hand-drawn NFTs minting on OpenSea 🌈')}`,
  },
];

/* ── Individual card ──────────────────────────────────────────── */
function PlatformCard({ name, tagline, cta, bg, text, border, Icon, href }) {
  const [copied, setCopied] = useState(false);

  function handleClick(e) {
    if (!href) {
      e.preventDefault();
      navigator.clipboard.writeText(`${SHARE_MSG}\n${SITE_URL}`).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
    }
  }

  const target = href ? href() : '#';

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      whileHover={{ y: -6, rotate: -0.5 }}
      className="rounded-3xl border-2 border-ink bg-card p-6 shadow-pop flex flex-col gap-4"
    >
      {/* Platform header */}
      <div className="flex items-center gap-3">
        <div
          className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border-2 border-ink"
          style={{ backgroundColor: bg, color: text }}
        >
          <Icon />
        </div>
        <div>
          <div className="font-bold text-base leading-tight">{name}</div>
          <div className="text-xs text-muted-foreground mt-0.5">{tagline}</div>
        </div>
      </div>

      {/* Preview pill */}
      <div className="rounded-xl border-2 border-ink bg-muted px-3 py-2 text-[11px] font-mono text-muted-foreground leading-snug line-clamp-2">
        {SHARE_MSG.substring(0, 80)}…
      </div>

      {/* CTA */}
      <a
        href={target}
        target={href ? '_blank' : undefined}
        rel="noopener noreferrer"
        onClick={handleClick}
        className="mt-auto flex items-center justify-center gap-2 rounded-full border-2 border-ink py-2.5 text-sm font-bold shadow-pop transition hover:-translate-y-0.5 active:translate-y-0"
        style={{ backgroundColor: bg, color: text }}
      >
        <Icon />
        {copied ? 'Copied ✓' : cta}
      </a>
    </motion.div>
  );
}

/* ── Section export ───────────────────────────────────────────── */
export default function SocialShareCards() {
  return (
    <section id="share" className="mx-auto max-w-6xl px-6 pb-24">
      <div className="text-center mb-12">
        <div className="inline-flex items-center gap-2 rounded-full border-2 border-ink bg-glum-yellow px-4 py-1 text-xs font-bold uppercase tracking-widest shadow-pop">
          🌈 Share the Vibes
        </div>
        <h2 className="mt-5 text-4xl sm:text-5xl font-bold">
          Spread the <span className="rainbow-text">Glum</span>
        </h2>
        <p className="mx-auto mt-3 max-w-md text-muted-foreground">
          Help the Glum-verse grow — shout it on your favourite platform.
        </p>
      </div>

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
        {platforms.map((p, i) => (
          <motion.div
            key={p.name}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.07 }}
          >
            <PlatformCard {...p} />
          </motion.div>
        ))}
      </div>
    </section>
  );
}